import styled from "styled-components";
import { motion } from "framer-motion";

interface GL_ContainerProps {
	$modulesCount: number;
}

export const GL_Container = styled(motion.div)<GL_ContainerProps>`
	display: grid;

	grid-template-columns: repeat(${({ $modulesCount }) => $modulesCount}, 220px);
	grid-auto-rows: 250px;
	min-width: 0;
	min-height: 0;
	gap: 20px 10px;
`;

export const groupsLessonVariants = {
	hidden: {
		opacity: 0,
		x: -24,
		scale: 0.98,
	},
	visible: {
		opacity: 1,
		x: 0,
		scale: 1,
		transition: {
			duration: 0.28,
			ease: [0.16, 1, 0.3, 1],
			delayChildren: 0.45,
			staggerChildren: 0.035,
		},
	},
	exit: {
		opacity: 0,
		x: -24,
		scale: 0.98,
		transition: {
			duration: 0.2,
			ease: "easeOut",
		},
	},
};

export const groupsLessonFadeVariants = {
	hidden: {
		opacity: 0,
	},
	visible: {
		opacity: 1,
		transition: {
			duration: 0.25,
			ease: "easeOut",
		},
	},
	exit: {
		opacity: 0,
		transition: {
			duration: 0.16,
			ease: "easeOut",
		},
	},
};
